export const API_GET_USER = "API_GET_USER";
export const USER_CHECK_AUTH_SERVICE = "USER_CHECK_AUTH_SERVICE";
